import axios from 'api/axios'
import { Invoice } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for getInvoices
 */

export interface getInvoicesParams {
	page: number
	size: number
	isPaid?: boolean
	client?: string
}

/**
 * Type Interface for the Response object you get from getInvoices request if successful
 */
export interface invoicesResponse {
	totalCount: number
	records: Invoice[]
	totalPages: number
	currentPage: number
}

export interface invoicesFilter {
	isPaid: boolean
}

export interface getInvoicesResponse {
	response: invoicesResponse
	filter: { isPaid: boolean }
}

/**
 * API call to get Invoices from the WhatCX Application
 * @param options getInvoicesParams - Options for the API call
 * @returns InvoiceResponse - Response object returned from the server
 */

export const getInvoices = async (options: getInvoicesParams) => {
	try {
		const { page = 1, size = 10, isPaid, client = '' } = options
		const { data } = await axios.get<getInvoicesResponse>(
			`client/bill/invoice?page=${page}&size=${size}${
				isPaid !== undefined ? `&isPaid=${isPaid}` : ''
			}${client.length > 0 ? `&client=${client}` : ''}`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getInvoices
